import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactPropertiesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ContactProperties",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.03 28.48V3.52a1.52 1.52 0 1 0-3.04 0v24.96a1.52 1.52 0 1 0 3.04 0M12.52 17h.01c.2 0 .4-.04.58-.12h-.01l11.98-5c.55-.23.92-.76.92-1.38s-.37-1.15-.91-1.38h-.01l-11.98-5c-.16-.06-.34-.1-.53-.1a1.5 1.5 0 0 0-1.5 1.48v9.98c0 .83.67 1.5 1.5 1.5h-.05Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.86 24.93c-.63 0-1.14-.51-1.14-1.14V3c0-.46.28-.88.71-1.06s.92-.08 1.25.25c2.73 2.73 7.31 4.24 12.91 4.24.43 0 .83.24 1.02.63s.15.85-.11 1.2c-.15.21-3.84 5.03-10.06 5.03a1.14 1.14 0 1 1 0-2.28c2.82 0 5.04-1.27 6.47-2.4-3.92-.34-7.31-1.43-9.89-3.19v18.37c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6 29.29a1.14 1.14 0 0 1-1.03-1.63c1.44-3.04 4.54-5.01 7.89-5.01s6.45 1.97 7.89 5.01a1.14 1.14 0 1 1-2.06.98c-1.08-2.28-3.31-3.7-5.82-3.7s-4.74 1.42-5.82 3.7c-.19.41-.61.65-1.03.65Z"
      })]
    })
  }));
};